import designTokensImage from '@images/design-tokens-explainer.png';
import nectarExample from '@images/design-tokens-nectar-example.png';
import * as React from 'react';
export default {
  designTokensImage,
  nectarExample,
  React
};